import React from 'react';
import { AuthLayout } from '../layouts/AuthLayout';
import { LoginForm } from '../components/auth/LoginForm';

export const LoginPage: React.FC = () => (
  <AuthLayout subtitle="관리자 로그인">
    <LoginForm />
  </AuthLayout>
);